import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-acordeon-container',
  templateUrl: './acordeon-container.component.html',
  styleUrls: ['./acordeon-container.component.scss']
})
export class AcordeonContainerComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/common/acordeon/acordeon-container/acordeon-container.component.ts